import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import {listDataSpecs} from '../utils/utilsDataSpec';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

class ListDataSpecs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            DataSpecs : null
        };

        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    const onLoad = function(arr){
        this.setState({
            DataSpecs: arr,
            renderState: 'loaded'
        });
        
        // Call parent's onLoad callback if provided
        if (this.state.onLoad){
            this.state.onLoad(arr.length);
        }
    }.bind(this);

    const onError = function(e){
        this.setState({
            renderState: 'failed',
            errorMessage: e.message
        });
    }.bind(this);

    listDataSpecs(this.dsd, filters, onLoad, onError);
}

setup(){

    let StateChange = {
        filters: {},
        columns: {
            owner:true,
            status:true
        },
        onLoad: null,
        renderState: 'loading'
    };

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }
    
    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }
    
    this.setState(StateChange);

    this.loadData(StateChange.filters);
        
}



    included(DataSpec) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }


        if (this.state.renderState === 'loaded') {
            let arrDataSpecs = this.state.DataSpecs;
            if (isArray(arrDataSpecs)){
                if (arrDataSpecs.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrDataSpecs.map(
                                    (DataSpec, pos) => 
                                    {
                                        if (this.included(DataSpec)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/dataspec/" + DataSpec.id} > {DataSpec.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {DataSpec.Owner &&
                                                                    DataSpec.Owner.organisation}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.status &&
                                                            <PD.Td>
                                                                {DataSpec.status}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(DataSpec.description, 400)}</PD.MdPresent>
                                                        </PD.Td>

                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListDataSpecs_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListDataSpecs {...props} navigation={navigation} location={location} params={params} />;
  }
